var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgBin = function SvgSvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 17.25A.75.75 0 0 1 9 16.5v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-.75.75ZM14.25 17.25a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-.75.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 21.75A2.252 2.252 0 0 1 4.5 19.5V6.75H2.25a.75.75 0 0 1 0-1.5H7.5V4.5a2.252 2.252 0 0 1 2.25-2.25h4.5A2.252 2.252 0 0 1 16.5 4.5v.75h5.25a.75.75 0 0 1 0 1.5H19.5V19.5a2.252 2.252 0 0 1-2.25 2.25H6.75ZM6 19.5c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75V6.75H6V19.5Zm9-14.25V4.5a.75.75 0 0 0-.75-.75h-4.5A.75.75 0 0 0 9 4.5v.75h6Z",
    fill: "currentColor"
  })));
};
export default SvgSvgBin;